import { AssertionsCell } from "../ComplexCells/AssertionsCell/AssertionsCell";
import { CompareDiffCell } from "../ComplexCells/CompareDiffCell";
import { FunctionCallCell } from "../ComplexCells/FunctionCallCell";
import { BooleanIcon } from "../primitives/utils";

import { ReportCell, ReportColumn, ColumnType } from "@/types/evaluate";
import { forceJSONString } from "@/utils/strings";

interface FullscreenComplexCellProps {
  cell: ReportCell;
  column: ReportColumn;
}

export const FullscreenComplexCell = ({ cell, column }: FullscreenComplexCellProps) => {
  // eslint-disable-next-line default-case
  switch (column.column_type) {
    case ColumnType.LLM_ASSERTION: {
      const prompt =
        typeof column.configuration.prompt === "string" &&
        column.configuration.prompt.startsWith("[")
          ? JSON.parse(column.configuration.prompt)[0]
          : column.configuration.prompt;
      return (
        <AssertionsCell
          prompt={cell.display_value.type === "object" ? "" : prompt}
          value={cell.display_value.value}
          isColumnSelected={false}
        />
      );
    }

    case ColumnType.COMPARE:
      if (
        (typeof cell.display_value.value === "boolean" && !cell.display_value.value) ||
        (typeof cell.display_value.value === "string" && cell.display_value.value !== "")
      ) {
        return <CompareDiffCell key={`${cell?.id}-compare`} cell={cell} />;
      }
      return (
        <div className="flex items-center justify-center">
          <BooleanIcon value />
        </div>
      );
  }

  switch (cell.display_value.type) {
    case "function":
    case "tool_calls":
      return <FunctionCallCell cell={cell} isColumnSelected={false} />;

    case "output_media": {
      const media = cell.display_value.value as { url?: string; media_type?: string };
      if (media?.url && (media.media_type === "image" || !media.media_type)) {
        return (
          <div className="flex items-center justify-center p-4">
            <img
              src={media.url}
              alt="Generated"
              className="max-h-[70vh] max-w-full object-contain"
            />
          </div>
        );
      }
      return <div className="text-sm text-gray-500">[Image]</div>;
    }

    case "object":
      return (
        <pre className="whitespace-pre-wrap text-sm text-gray-800">
          {forceJSONString(cell.display_value.value)}
        </pre>
      );

    case "boolean":
      return (
        <div className="flex items-center justify-center">
          <BooleanIcon value={cell.display_value.value as boolean} />
        </div>
      );

    case "unknown":
      return (
        <div className="flex items-center justify-center p-2 text-xs text-gray-700">
          {cell.display_value.value ||
            (typeof cell?.value?.value === "string"
              ? cell?.value?.value
              : JSON.stringify(cell?.value?.value)) ||
            "—"}
        </div>
      );

    default:
      return (
        <div className="whitespace-pre-wrap text-sm">
          {/* eslint-disable-next-line @typescript-eslint/no-explicit-any */}
          {(cell.display_value as any).value
            ? // eslint-disable-next-line @typescript-eslint/no-explicit-any
              String((cell.display_value as any).value)
            : "—"}
        </div>
      );
  }
};
